module.exports = __webpack_public_path__ + "static/racing-790da53556c68540d36ee1865c1fe7bf.png";